import classNames from 'classnames/bind';
import styles from './Footer.module.css';
import { Link } from 'react-router-dom';

import Logo from '../../../../components/Logo';

import {
  FOOTER_MENU,
  FOOTER_LINK,
  ADDRESS,
  BUSINESS_REGISTRATION_NUMBER,
  CEO,
  COPYRIGHT,
} from '../../../../constants';
import { StringByKey } from '../../../../types/common';
import LanguageSelector from '../../../../components/LanguageSelector';

export default function Footer() {
  const cx = classNames.bind(styles);

  const path: StringByKey = {
    Notice: './settings/notice',
    Faq: './settings/faq',
    PrivacyPolicy: './settings/privacy-policy',
    Terms: './settings/terms',
  };

  return (
    <div className={cx('footer_area')}>
      <h2>
        <Logo />
      </h2>

      <div className={cx('foot_box')}>
        <div className={cx('cont_link')}>
          <ul>
            {Object.entries(FOOTER_MENU).map(([key, value]) => (
              <li key={key}>
                <Link to={path[key]} className={cx('btn')}>
                  {value}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className={cx('info')}>
          <span>{ADDRESS}</span>
          <span>{BUSINESS_REGISTRATION_NUMBER}</span>
          <span>{CEO}</span>
          <br />
          <span>{COPYRIGHT}</span>
        </div>
      </div>

      <LanguageSelector location="footer" />

      <div className={cx('family_box')}>
        <button className={cx('btn', 'open_family')}>Family Site</button>
        <div className={cx('family_link')}>
          {Object.entries(FOOTER_LINK).map(([key, value]) => (
            <a key={key} href={value} target="_blank">
              {key}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
